import React from 'preact/compat';
import { addItem, applyDiscountCode } from './Cart';
import { notifyHandledException } from '../../utils/errorLogger';
import { toShopifyGlobalId } from '../storefront-cart';
import { useState } from 'preact/hooks';

type AddToCartComponent = React.FC<{
  variantId: number | string;
  onDone?: () => void;
  properties?: Record<string, string>;
  ariaLabel: string;
  sellingPlanId?: string;
  discountCode?: string;
}>;

export const AddToCart: AddToCartComponent = ({
  variantId,
  onDone,
  children,
  sellingPlanId,
  discountCode,
  ...attributes
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const addProductToCart = async (): Promise<void> => {
    setIsAdding(true);
    try {
      if (discountCode) {
        await applyDiscountCode(discountCode);
      }
      await addItem(toShopifyGlobalId(variantId.toString()), 1, sellingPlanId);
    } catch (error: any) {
      notifyHandledException(error);
    } finally {
      setIsAdding(false);
      onDone && onDone();
    }
  };
  return (
    <button
      class={'button button-secondary'}
      disabled={isAdding}
      onClick={() => addProductToCart()}
      {...attributes}
    >
      {children}
    </button>
  );
};
